import FirebaseConfig from './FirebaseConfig'

export const identityURL = {
  resetPassword: `https://identitytoolkit.googleapis.com/v1/accounts:resetPassword?key=${FirebaseConfig.apiKey}`,
  updateVerifyEmail: `https://identitytoolkit.googleapis.com/v1/accounts:update?key=${FirebaseConfig.apiKey}`,
}
